import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { createContainer } from '@dbk-legacy/muster/react';
import Settings from '../../../data/settings';
import SimpleDate from '../../../components/common/date';
import Text, { Small, Large } from '@dbk/ui-text';
const propTypes = {
  dataInfo: PropTypes.array.isRequired,
  key: PropTypes.string
};

class FeatureBlock extends PureComponent {
  constructor(props) {
    super(props);

    this.detectIE = this.detectIE.bind(this);
  }

  detectIE() {

    var oReturn = false;

    var isIE = !!navigator.userAgent.match(/Trident/g) || !!navigator.userAgent.match(/MSIE/g);

    if(isIE){
      oReturn = true;
    }
    else{
      oReturn = false;
    }


    return oReturn;




  }


  render() {
    const IEdetection = this.detectIE();
    const changePage = this.props.changePage;
    const { i18n: { messages } } = this.props;
    const blankImage = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAA+gAAALuAQAAAAAV9gHgAAAACXBIWXMAAABIAAAASABGyWs+AAAAcklEQVR42u3BMQEAAADCoPVPbQlPoAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADgY3EzAAFPD7s3AAAANHRFWHRjb21tZW50ACBDUkVBVE9SOiBDSW1nIDogT3JpZ2luYWwgc2l6ZT0xMDAweDc1MHgxeDMKMNWJ6AAAACV0RVh0ZGF0ZTpjcmVhdGUAMjAxNy0wOC0yMVQwMzo0ODoyNC0wNTowMCV8EqUAAAAldEVYdGRhdGU6bW9kaWZ5ADIwMTctMDgtMjFUMDM6NDg6MjQtMDU6MDBUIaoZAAAAAElFTkSuQmCC";
    const block1 = this.props.dataInfo.map(function (article, i) {
      const isBlank = article.image.uri == "" ? blankImage : article.image.uri;
      const titleTrim = article.title.substring(100, 0) + "...";
      const descTrim = article.desc.substring(150, 0) + "...";


      const articleTitle = (IEdetection &&  article.title.length > 100) ? titleTrim : article.title;
      const articleDesc =  (IEdetection &&  article.desc.length > 150)  ? descTrim : article.desc;




      if (i == 0) {
        return (
          <a onClick={() => changePage('/insights/article/' + article.articleId , true)}>

            <div className="row no-margin border-bottom-col">
              <div className="row no-margin feature-info-panel">
                <div className="small-12 medium-12 large-8 column no-margin no-padding ">
                  {/* <img className="featureImage" src={isBlank}/> */}

                  <div className="image-box" style={{ background: 'url(' + isBlank + ')', backgroundSize: 'cover', backgroundPosition: "50% 50%" }} >
                    <img className="ghost" src={'../' + Settings.webfolder + '/images/apac/box.png'} />
                  </div>




                </div>

                <div className="small-12 medium-12 large-4 column">

                  <h1 className="article-title title-ellipsis">{articleTitle}</h1>
                  <p className="article-date"><SimpleDate value={article.date} /></p>
                  <p className="feature-text feature-ellipsis">{articleDesc}</p>
                  <a className="text read-more" id="text_learnMore_featureBlock_test">{messages['app.insight.readMore']}</a>
                </div>
              </div>

            </div>


          </a>
        )
      }
    });

    return (<div>{block1}</div>);

  }
}

FeatureBlock.PropTypes = propTypes;


export default createContainer({
  $queries: {
    changePage: { $call: 'ui.history.push' },
    i18n: {
      messages: true,
    },

  }
})(FeatureBlock);

